<template>
  <common-dialog ref="dialog" width="70%" title="回收详情" @closed="onClosed">
    <template slot="form">
      <el-table :data="data" border>
        <el-table-column prop="address" label="收货地址" min-width="300">
          <template slot-scope="{row}">
            {{ row.address }}
          </template>
        </el-table-column>
        <el-table-column prop="no" label="订单号" width="200" />
        <el-table-column prop="expressNo" label="运单号" width="200">
          <template slot-scope="{row}">
            <div>
              <div>圆通快递</div>
              <div>{{ row.expressNo }}</div>
            </div>
            <div>
              <span style="color: #D9001B;">已回收</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="msg" label="回收时间" width="160">
          <template slot-scope="{row}">
            {{ row.time }}
          </template>
        </el-table-column>
      </el-table>
    </template>
    <template slot="footer">
      <el-button @click="close">关 闭</el-button>
    </template>
  </common-dialog>
</template>
<script>
import dialogMixin from '@/mixins/dialog';
import commonDialog from '@/components/common/dialog';

export default {
  mixins: [dialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: []
    };
  },
  methods: {
    getData(data) {
      console.log("data", data);
      this.data.push({
        address: "丁，19597423186，浙江省/舟山市/岱山县/浙江省舟山市岱山县高亭镇安澜路189号310[0742]",
        no: "240318-529897952651816",
        expressNo: "YT8962139805106",
        time: "2024-03-20 15:00:00"
      })
    },
    onClosed() {
      this.data = [];
    }
  },
};
</script>
<style lang="scss" scoped>
.head-box {
  line-height: 40px;
  padding-left: 10px;
  border: 1px solid #EBEEF5;
  border-bottom: none;
}
</style>